(() => {
  if (window.__kaCreditOfferBootstrapped) {
    return;
  }

  window.__kaCreditOfferBootstrapped = true;

  const offerSelector = '[data-ka-credit-offer]';

  const thresholds = [
    {
      thresholdCents: 25000,
      rewardCents: 2500
    },
    {
      thresholdCents: 50000,
      rewardCents: 5000
    },
    {
      thresholdCents: 100000,
      rewardCents: 15000
    },
    {
      thresholdCents: 200000,
      rewardCents: 35000
    }
  ];

  const maximumThresholdCents =
    thresholds[thresholds.length - 1].thresholdCents;

  const maximumRewardCents =
    thresholds[thresholds.length - 1].rewardCents;

  let refreshTimer = null;

  function getFirstOffer() {
    return document.querySelector(offerSelector);
  }

  function getCartUrl() {
    const offer = getFirstOffer();

    return offer?.dataset.cartUrl || '/cart.js';
  }

  function getFallbackCurrency() {
    const offer = getFirstOffer();

    return offer?.dataset.currency || 'AUD';
  }

  function formatMoney(cents, currencyCode) {
    const amount =
      Math.max(0, Number(cents) || 0) / 100;

    const hasCents =
      !Number.isInteger(amount);

    try {
      return new Intl.NumberFormat('en-AU', {
        style: 'currency',
        currency:
          currencyCode ||
          getFallbackCurrency(),
        minimumFractionDigits:
          hasCents ? 2 : 0,
        maximumFractionDigits: 2
      }).format(amount);
    } catch (error) {
      return '$' + amount.toFixed(
        hasCents ? 2 : 0
      );
    }
  }

  function updateOffer(
    offer,
    totalCents,
    currencyCode
  ) {
    const safeTotal =
      Math.max(0, Number(totalCents) || 0);

    const currency =
      currencyCode ||
      offer.dataset.currency ||
      getFallbackCurrency();

    const nextTierIndex =
      thresholds.findIndex(
        tier =>
          safeTotal < tier.thresholdCents
      );

    const messageElement =
      offer.querySelector(
        '[data-ka-credit-message]'
      );

    if (messageElement) {
      if (nextTierIndex === -1) {
        messageElement.textContent =
          'You have unlocked the maximum ' +
          formatMoney(
            maximumRewardCents,
            currency
          ) +
          ' credit back';
      } else {
        const nextTier =
          thresholds[nextTierIndex];

        const remaining =
          nextTier.thresholdCents -
          safeTotal;

        messageElement.textContent =
          'Add ' +
          formatMoney(
            remaining,
            currency
          ) +
          ' more to unlock ' +
          formatMoney(
            nextTier.rewardCents,
            currency
          ) +
          ' back';
      }
    }

    const progressElement =
      offer.querySelector(
        '[data-ka-credit-progress]'
      );

    if (progressElement) {
      const cappedTotal =
        Math.min(
          safeTotal,
          maximumThresholdCents
        );

      progressElement.setAttribute(
        'aria-valuenow',
        String(cappedTotal / 100)
      );

      progressElement.setAttribute(
        'aria-valuetext',
        formatMoney(
          cappedTotal,
          currency
        ) +
        ' of ' +
        formatMoney(
          maximumThresholdCents,
          currency
        )
      );
    }

    thresholds.forEach(
      (tier, index) => {
        const previousThreshold =
          index === 0
            ? 0
            : thresholds[index - 1]
                .thresholdCents;

        const tierRange =
          tier.thresholdCents -
          previousThreshold;

        const progressWithinTier =
          Math.min(
            Math.max(
              safeTotal -
                previousThreshold,
              0
            ),
            tierRange
          );

        const progressPercentage =
          tierRange > 0
            ? (
                progressWithinTier /
                tierRange
              ) * 100
            : 0;

        const fill =
          offer.querySelector(
            '[data-ka-progress-fill="' +
              index +
              '"]'
          );

        if (fill) {
          fill.style.width =
            Math.max(
              0,
              Math.min(
                progressPercentage,
                100
              )
            ) + '%';
        }
      }
    );

    const tierElements =
      offer.querySelectorAll(
        '[data-ka-credit-tier]'
      );

    tierElements.forEach(
      (tierElement, index) => {
        const tier =
          thresholds[index];

        if (!tier) {
          return;
        }

        const statusElement =
          tierElement.querySelector(
            '[data-ka-credit-status]'
          );

        tierElement.classList.remove(
          'is-locked',
          'is-current',
          'is-unlocked'
        );

        if (
          safeTotal >=
          tier.thresholdCents
        ) {
          tierElement.classList.add(
            'is-unlocked'
          );

          if (statusElement) {
            statusElement.textContent =
              'Unlocked';
          }

          return;
        }

        if (
          index === nextTierIndex
        ) {
          const remaining =
            tier.thresholdCents -
            safeTotal;

          tierElement.classList.add(
            'is-current'
          );

          if (statusElement) {
            statusElement.textContent =
              '+' +
              formatMoney(
                remaining,
                currency
              ) +
              ' to go';
          }

          return;
        }

        tierElement.classList.add(
          'is-locked'
        );

        if (statusElement) {
          statusElement.textContent =
            'Locked';
        }
      }
    );

    offer.dataset.cartTotalCents =
      String(safeTotal);

    offer.dataset.currency =
      currency;
  }

  function updateAllOffers(
    totalCents,
    currencyCode
  ) {
    document
      .querySelectorAll(offerSelector)
      .forEach(offer => {
        updateOffer(
          offer,
          totalCents,
          currencyCode
        );
      });
  }

  function initialiseOffers(
    container = document
  ) {
    const offers = [];

    if (
      container.matches &&
      container.matches(offerSelector)
    ) {
      offers.push(container);
    }

    if (container.querySelectorAll) {
      container
        .querySelectorAll(offerSelector)
        .forEach(offer => {
          offers.push(offer);
        });
    }

    offers.forEach(offer => {
      updateOffer(
        offer,
        Number(
          offer.dataset
            .cartTotalCents || 0
        ),
        offer.dataset.currency ||
          getFallbackCurrency()
      );
    });
  }

  window.__kaCreditOfferNativeFetch =
    window.__kaCreditOfferNativeFetch ||
    window.fetch.bind(window);

  const nativeFetch =
    window.__kaCreditOfferNativeFetch;

  async function refreshCreditOffer() {
    const offer = getFirstOffer();

    if (!offer) {
      return;
    }

    try {
      const response =
        await nativeFetch(
          getCartUrl(),
          {
            method: 'GET',
            credentials: 'same-origin',
            headers: {
              Accept: 'application/json'
            },
            cache: 'no-store'
          }
        );

      if (!response.ok) {
        return;
      }

      const cart =
        await response.json();

      updateAllOffers(
        Number(
          cart.total_price || 0
        ),
        cart.currency ||
          getFallbackCurrency()
      );
    } catch (error) {
      console.warn(
        'KickAss credit offer could not refresh:',
        error
      );
    }
  }

  function scheduleRefresh(
    delay = 180
  ) {
    window.clearTimeout(
      refreshTimer
    );

    refreshTimer =
      window.setTimeout(() => {
        refreshCreditOffer();
      }, delay);
  }

  function bindCartListeners() {
    window.fetch =
      async function (...args) {
        const response =
          await nativeFetch(...args);

        try {
          const request = args[0];

          const requestUrl =
            typeof request ===
            'string'
              ? request
              : request?.url || '';

          const isCartMutation =
            /\/cart\/(add|change|update|clear)(?:\.js)?(?:[?#]|$)/i
              .test(requestUrl);

          if (isCartMutation) {
            scheduleRefresh(200);
          }
        } catch (error) {
          console.warn(
            'KickAss credit offer cart detection failed:',
            error
          );
        }

        return response;
      };

    const cartEvents = [
      'cart:updated',
      'cart:change',
      'cart:refresh',
      'cart-drawer:refresh',
      'product:added'
    ];

    cartEvents.forEach(
      eventName => {
        document.addEventListener(
          eventName,
          event => {
            const eventCart =
              event.detail?.cart ||
              event.detail;

            if (
              eventCart &&
              typeof eventCart
                .total_price ===
                'number'
            ) {
              updateAllOffers(
                eventCart.total_price,
                eventCart.currency ||
                  getFallbackCurrency()
              );
            } else {
              scheduleRefresh();
            }
          }
        );
      }
    );

    document.addEventListener(
      'submit',
      event => {
        const form =
          event.target?.closest?.(
            'form[action*="/cart/add"]'
          );

        if (form) {
          scheduleRefresh(700);
        }
      },
      true
    );

    document.addEventListener(
      'shopify:section:load',
      event => {
        initialiseOffers(
          event.target
        );

        scheduleRefresh(50);
      }
    );

    window.addEventListener(
      'pageshow',
      () => {
        scheduleRefresh(50);
      }
    );
  }

  function bootCreditOffer() {
    initialiseOffers();
    bindCartListeners();

    window.KACreditOfferRefresh =
      refreshCreditOffer;
  }

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      bootCreditOffer,
      {
        once: true
      }
    );
  } else {
    bootCreditOffer();
  }
})();